import React from 'react';
import styled from 'styled-components';
import { Text } from '@companycam/slab-web';
import Logo from 'images/All_Black.png';

// TipTap
import { useTiptapEditor, WebEditor } from '@companycam/tiptap-editor';

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: var(--cc_size_spacing_l);
`;

const TryCompanyCamButton = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  padding: var(--cc_size_spacing_s);
  border-radius: var(--cc_size_spacing_s);

  &:hover {
    img {
      opacity: 1;
    }
  }

  img {
    width: auto;
    height: 28px;
    margin-right: var(--cc_size_spacing_s);
    opacity: 0.3;
    transition: opacity 250ms ease-in-out;
  }
`;

const TipTapContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-top: calc(var(--cc_size_spacing_xxl) * 2);
  max-width: 960px;
  min-height: calc(100vh - var(--cc_size_spacing_xxl) * 2);
`;

type ShareProjectPageProps = {
  page: {
    title: string;
    tiptap_content: {
      content: unknown[];
    };
  };
};

const ShareProjectPage = ({ page }: ShareProjectPageProps) => {
  const initialContent =
    page?.tiptap_content?.content?.length > 0 ? page.tiptap_content : null;
  const { editor: tiptapEditor } = useTiptapEditor({
    initialContent,
    editable: false,
  });

  return tiptapEditor ? (
    <TipTapContainer data-testid="project-page">
      <WebEditor
        title={page.title}
        editor={tiptapEditor}
        isLightGalleryEnabled
      />
      <Footer>
        <Text as="span" size="xs" family="heading" color="nonessential">
          Page powered by
        </Text>
        <TryCompanyCamButton
          href="https://app.companycam.com/signup"
          target="_blank"
        >
          <img src={Logo} alt="CompanyCam Logo" />
        </TryCompanyCamButton>
      </Footer>
    </TipTapContainer>
  ) : null;
};

export default ShareProjectPage;
